import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
export var EcomStateDirective = [
    '$q',
    function ($q) {
        return {
            link: function ($scope, $element) {
                $q.when(fetchEcomSetting())
                    .then(function (setting) {
                    var cssClass = setting.ecomEnabled ? 'ecom-enabled' : 'ecom-disabled';
                    $element.addClass(cssClass);
                });
            },
            restrict: 'A',
        };
    },
];
